var exports = {
  "n": "x31de4314--50c048--link",
};

module.exports = exports;
